module.exports = __webpack_public_path__ + "img/ring_skip_0_0_null.fd4a1724.png";